import type { CreditorKeyValuePair } from 'api';

import type { DraftSteps } from './types';

import type { StepFieldDefinitions } from '../hooks/useDraftStepFields';

export const loadReceiverInformation = (
  details: CreditorKeyValuePair[],
  fields: StepFieldDefinitions,
  step: DraftSteps
) => {
  const stepDetails = details.reduce(
    (values, { key, value }) => {
      const field = fields.find((field) => field.fullName === key);

      if (field === undefined) {
        return values;
      }

      return {
        ...values,
        [field.name]: value
      };
    },
    {} as Record<string, unknown>
  );

  if (Object.keys(stepDetails).length === 0) {
    return undefined;
  }

  return { [step]: stepDetails };
};
